import FormErrorMessage from './FormErrorMessage';

// export types
export type { FormErrorMessageProps } from './FormErrorMessage';

// export components
export { FormErrorMessage };
export default FormErrorMessage;
